import { Routes, Route } from 'react-router-dom';
import BroadcastPage from '../pages/dashboard/components/pages/BroadcastPage';
import EmailCampaigns from '../pages/email/campaigns/EmailCampaigns';
import EmailCampaignCreate from '../pages/email/campaigns/EmailCampaignCreate';
import EmailCampaignDetail from '../pages/email/campaigns/EmailCampaignDetail';
import { useChannelMode } from '../context/channelModeContext';
import '../pages/email/shared/emailDesign.css';

export default function BroadcastRoute() {
  const { isEmail } = useChannelMode();

  if (isEmail) {
    return (
      <Routes>
        <Route index element={<EmailCampaigns />} />
        <Route path="new" element={<EmailCampaignCreate />} />
        <Route path=":id/edit" element={<EmailCampaignCreate />} />
        <Route path=":id" element={<EmailCampaignDetail />} />
      </Routes>
    );
  }

  return <BroadcastPage />;
}
